import {
  combineReducers,
} from 'redux';

import {
  coreReducers,
} from '@gymcloud/core';
import ui from './ui';

const appReducer = combineReducers({
  ui,
  ...coreReducers,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOG_OUT') {
    return appReducer(
      {
        ui: state.ui,
      },
      action,
    );
  }

  return appReducer(state, action);
};

export default rootReducer;
